import { IPageLoad } from './IPageLoad';
import { IRecentDelete } from './IRecentDelete';
import { IRefinerClick } from './IRefinerClick';
import { IResultClick } from './IResultClick';
import { ISearch } from './ISearch';

//interface for analytics schema
export interface IAnalyticsTasks {
    id?: string;
    sessionType?: string;
    eventData?:
      | ISearch
      | IPageLoad
      | IResultClick
      | IRefinerClick
      | IRecentDelete;
    query?: Array<ISearch>;
    loadPage?: Array<IPageLoad>;
    document?: Array<IResultClick>;
    recentDelete?: Array<IRecentDelete>;
    refiner?: Array<IRefinerClick>;
}

//interface for analytics base model
export interface IBaseEvent {
  SessionID: string |null;
  Time: string | null;
  Site: string | null;
  WebUrl?: string;
  Action: string  | null;
  User: string | null;
  AccountName?: string | undefined;
  PageURL: string | null;
  PreferredName?: string | undefined;
  pax_ixevent?: string;
  UserServiceLine?: string | null;
  UserSubserviceline?: string | null;
  UserArea?: string | null;
  UserCountry?: string | null;
  UserRank?: string | null;
  UserSpecialityName?: string | null;
}

//Enum for Analytics Actions
export enum AnalyticsActions {
  query = 'Query',
  pageLoad = 'LoadPage',
  resultItem = 'OpenResultItem',
  recentDelete = 'RecentDelete',
  refiner = 'ApplyRefiner'
}
